/**
 * Константы приложения
 */

// DOM селекторы
export const SELECTORS = {
  // Поиск
  SEARCH_INPUT: '#searchInput',

  // Категории
  CATEGORIES_LIST: '#categoriesList',
  SELECTED_CATEGORIES: '#selectedCategories',

  // Фильмы
  MOVIES_CONTAINER: '#moviesContainer',
  NO_RESULTS: '#noResults',

  // Сортировка
  SORT_BUTTON: '#sortButton',
  SORT_ORDER_BUTTON: '#sortOrderButton',
  SORT_DROPDOWN: '#sortDropdown',
  SORT_OPTION: '.sort-option',

  // Навигация
  NAVIGATION_BAR: '#navigationBar',
  STICKY_LOGO: '.sticky-logo',
  SCROLL_TO_TOP_BTN: '#scrollToTopBtn',

  // Popup
  CONTACTS_LINK: '#contactsLink',
  CONTACTS_POPUP: '#contactsPopup',
  CLOSE_POPUP: '#closePopup',
  PRICE_LINK: '#priceLink',

  // Sidebar и категории
  SIDEBAR: '.sidebar',
  CATEGORIES_LIST: '#categoriesList',
  CATEGORIES_TOGGLE: '#categoriesToggle',
  CATEGORIES_NAV: '#categoriesNav',
  SIDEBAR_OVERLAY: '#sidebarOverlay',

  // Общие
  CONTAINER: '.container',
  MAIN_CONTENT: '.main-content',
  SIDEBAR: '.sidebar',
};

// CSS классы
export const CSS_CLASSES = {
  // Состояния
  ACTIVE: 'active',
  HIDDEN: 'hidden',
  SHOW: 'show',
  STICKY: 'sticky',
  LOADING: 'loading',

  // Анимации
  FADE_IN: 'fade-in',
  SLIDE_UP: 'slide-up',

  // Компоненты
  MOVIE_CARD: 'movie-card',
  CATEGORY_ITEM: 'category-item',
  CATEGORY_COUNT: 'category-count',
  SELECTED_CATEGORY_TAG: 'selected-category-tag',
  REMOVE_TAG: 'remove-tag',
  CLEAR_ALL: 'clear-all',

  // Префиксы для категорий
  CATEGORY_PREFIX: 'category-',
  MOVIE_CARD_PREFIX: 'movie-card-',
};

// Настройки поиска
export const SEARCH_CONFIG = {
  DEBOUNCE_DELAY: 300, // мс
  MIN_QUERY_LENGTH: 1,
  MAX_RESULTS: 50,
};

// Настройки анимации
export const ANIMATION_CONFIG = {
  SCROLL_THRESHOLD: 300, // px для показа кнопки "наверх"
  TRANSITION_DURATION: 300, // мс
  STAGGER_DELAY: 50, // мс между анимациями элементов
};

// Настройки навигации
export const NAVIGATION_CONFIG = {
  SCROLL_OFFSET: 80, // px смещение для sticky навигации
  SMOOTH_SCROLL_DURATION: 500, // мс
};

// Типы сортировки
export const SORT_TYPES = {
  ALPHABET: 'alphabet',
  CATEGORY: 'category',
  DURATION: 'duration',
  DATE: 'date',
};

// Порядок сортировки
export const SORT_ORDERS = {
  ASC: 'asc',
  DESC: 'desc',
};

// Breakpoints для responsive дизайна
export const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1200,
};

// События приложения
export const EVENTS = {
  // Поиск
  SEARCH: 'search',
  SEARCH_CLEAR: 'search:clear',

  // Категории
  CATEGORIES_CHANGED: 'categoriesChanged',
  CATEGORY_TOGGLE: 'category:toggle',
  CATEGORIES_CLEAR: 'categories:clear',

  // Сортировка
  SORT_CHANGED: 'sortChanged',
  SORT_TYPE_CHANGED: 'sort:type:changed',
  SORT_ORDER_CHANGED: 'sort:order:changed',

  // UI
  SCROLL_TO_TOP: 'scrollToTop',
  MOVIES_RENDERED: 'movies:rendered',
  CATEGORIES_RENDERED: 'categories:rendered',

  // Popup
  CONTACTS_OPEN: 'contactsOpen',
  CONTACTS_CLOSE: 'contactsClose',

  // Навигация
  NAVIGATION_STICKY: 'navigation:sticky',
  NAVIGATION_NORMAL: 'navigation:normal',

  // Данные
  DATA_LOADED: 'data:loaded',
  DATA_ERROR: 'data:error',
};

// Сообщения пользователю
export const MESSAGES = {
  NO_RESULTS: {
    title: 'Фильмы не найдены',
    description: 'Попробуйте изменить поисковый запрос или сбросить фильтры',
  },
  LOADING: 'Загрузка...',
  ERROR: 'Произошла ошибка',
  NETWORK_ERROR: 'Ошибка сети. Проверьте подключение к интернету.',
};

// Настройки по умолчанию
export const DEFAULTS = {
  SORT_TYPE: SORT_TYPES.ALPHABET,
  SORT_ORDER: SORT_ORDERS.ASC,
  SELECTED_CATEGORIES: [],
  SEARCH_QUERY: '',
};

// Атрибуты данных
export const DATA_ATTRIBUTES = {
  CATEGORY: 'data-category',
  MOVIE_ID: 'data-movie-id',
  SORT_TYPE: 'data-sort',
  TOGGLE: 'data-toggle',
};

// URL для загрузки данных (относительные пути)
export const DATA_URLS = {
  MOVIES: '/src/data/movies.json',
  CATEGORIES: '/src/data/categories.json',
};

// Конфигурация кэширования
export const CACHE_CONFIG = {
  TTL: 5 * 60 * 1000, // 5 минут в мс
  MAX_SIZE: 10, // максимальное количество элементов в кэше
};

// Настройки производительности
export const PERFORMANCE_CONFIG = {
  VIRTUAL_SCROLL_THRESHOLD: 100, // количество элементов для включения виртуального скролла
  INTERSECTION_THRESHOLD: 0.1, // порог для Intersection Observer
  PASSIVE_LISTENERS: true, // использовать passive listeners для производительности
};

// Accessibility настройки
export const A11Y_CONFIG = {
  FOCUS_TRAP: true,
  ARIA_LIVE_DELAY: 100, // мс задержка для screen readers
  KEYBOARD_NAVIGATION: true,
};

// Regex паттерны
export const REGEX_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^[\d\s\-+()]+$/,
  SEARCH_CLEANUP: /[^\w\s\u0400-\u04FF]/gi, // очистка поискового запроса
};
